export enum UserPermissions {
  VIEW = 'VIEW',
  EDIT = 'EDIT',
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  ALL = 'ALL',
}
